module.exports = __webpack_public_path__ + "img/ph_paper2.109ab8f1.jpg";